<!--suppress JSUnresolvedFunction, CssUnusedSymbol, JSUnresolvedVariable -->
<template>
    <div v-if="companyRegistrationEnabled" id="companyForm">
      <div class="field left aligned">
        <div id="companyMode" class="ui toggle checkbox">
            <input tabindex="0" id="companySwitch" type="checkbox" :checked="createCompany" @click="switchCompanyMode"/>
            <label for="companySwitch"
                   v-text="createCompany ? $t('pages.registration.addCompanyChecked') : $t('pages.registration.addCompany')"></label>
        </div>
      </div>
      <div v-for="(field, i) in companyProfileFields" v-bind:key="field.fieldId">
        <validated-field v-if="createCompany && field.selectableValues && field.selectableValuesList"
            :id="companyProfileFields[i].fieldId + '-errors'"
            :show-errors-on="showErrors" :has-any-errors="!isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i)"
            :validation-rules="[
                            {value: !createCompany, showOn: !isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i), msg: getCompanyProfileFieldError(companyProfileFields[i].fieldId, i)}]">
          <dropdown-select v-if="isMobile()" :id="companyProfileFields[i].fieldId" :name="companyProfileFields[i].fieldId" v-model="companyProfileFieldValues[companyProfileFields[i].fieldId]"
                          classes="ui fluid dropdown selection"
                          :placeholder="companyProfileFields[i].localizedName"
                          :mandatory="true"
                          @change="onInput(); fetchCompanyProfileFieldsData();"
                          :options="companyProfileFields[i].selectableValuesList"
                          :invalid="!isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i)"></dropdown-select>
          <dropdown-mk2 v-else :id="companyProfileFields[i].fieldId" v-model="companyProfileFieldValues[companyProfileFields[i].fieldId]"
                        :placeholder="companyProfileFields[i].localizedName"
                        :options="companyProfileFields[i].selectableValuesList"
                        :mandatory="true"
                        @change="onInput(); fetchCompanyProfileFieldsData();"
                        :aria-error-element-id="companyProfileFields[i].fieldId + '-errors'"
                        :invalid="!isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i)"></dropdown-mk2>
        </validated-field>
        <validated-field v-else-if="createCompany" :show-errors-on="showErrors" :has-any-errors="!isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i)"
                          :id="companyProfileFields[i].fieldId + '-errors'"
                          :validation-rules="[
                            {value: !createCompany, showOn: !isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i), msg: getCompanyProfileFieldError(companyProfileFields[i].fieldId, i)}]">
          <labeled-input-field :id="companyProfileFields[i].fieldId" v-model="companyProfileFieldValues[companyProfileFields[i].fieldId]"
                              autocomplete="given-name"
                              :label="companyProfileFields[i].localizedName"
                              :mandatory="true"
                              :aria-error-element-id="companyProfileFields[i].fieldId + '-errors'"
                              @enter-pressed.prevent="onContinue"
                              @input="onInput"
                              :invalid="!isCompanyProfileFieldValid(companyProfileFields[i].fieldId, i)"></labeled-input-field>
        </validated-field>
      </div>
    </div>
</template>

<script>

import LabeledInputField from '../components/LabeledInputField.vue'
import ValidatedField from '../components/ValidatedField.vue'
import DropdownMk2 from '../components/DropdownMk2.vue'
import DropdownSelect from '../components/DropdownSelect.vue'
import { brand } from '../js/brand.js'
import { mixin } from '../js/ciam-mixin.js'
import * as validate from '../js/validation.js'
import repository from '../js/api/repository.js'

export default {
  components: {
    DropdownSelect,
    DropdownMk2,
    LabeledInputField,
    ValidatedField
  },
  mixins: [mixin, brand],
  props: {
    formPrefill: {
      type: Object
    }
  },
  data: function () {
    return {
      showErrors: false,
      showDropdownErrors: false,
      createCompany: this.$store.state.isCompanyRegistrationFieldsVisible,
      companyProfileFields: {},
      companyProfileFieldValues: {}
    }
  },
  methods: {
    switchCompanyMode: function () {
      this.createCompany = !this.createCompany
      // this.fetchCompanyProfileFieldsData()
    },
    getSelectableValuesList: function (object) {
      var list = {}
      for (let i = 0; i < object.length; i++) {
        list[object[i].key] = object[i].description
      }
      return list
    },
    fetchCompanyProfileFieldsData: function () {
      if (this.companyRegistrationEnabled) {
        var country = this.$parent.$parent.country
        for (const [key, value] of Object.entries(this.companyProfileFieldValues)) {
          if (key === 'ADDRESS_COUNTRY') {
            country = value
          }
        }
        const payload = this.$api.payloads.buildCompanyProfileFieldsPayload(this.$parent.$parent.language, country)
        repository.company.getCompanyProfileFieldsData(payload, this.onFetchCompanyFieldsDataSuccess, this.onFetchCompanyFieldsDataFailed)
      }
    },
    onFetchCompanyFieldsDataSuccess: function (resp) {
      var completeResponse = JSON.parse(resp)
      if (completeResponse && completeResponse.customerDataFields) {
        this.companyProfileFields = completeResponse.customerDataFields.filter(obj => obj.fieldUsage === 'MANDATORY')
        for (let i = 0; i < this.companyProfileFields.length; i++) {
          var item = this.companyProfileFields[i]
          var isDropdown = false
          if (item.selectableValues && item.selectableValues.selectableValues) {
            var selectableValuesList = this.getSelectableValuesList(item.selectableValues.selectableValues)
            item.selectableValuesList = selectableValuesList
            isDropdown = true
          }
          if (this.companyProfileFieldValues[item.fieldId] === undefined) {
            if (isDropdown) {
              if (item.fieldId === 'ADDRESS_COUNTRY') {
                this.companyProfileFieldValues[item.fieldId] = this.getInitialCountry()
              } else {
                if (item.selectableValuesList.length > 0) {
                  this.companyProfileFieldValues[item.fieldId] = item.selectableValuesList[0].key
                } else {
                  this.companyProfileFieldValues[item.fieldId] = ''
                }
              }
            } else {
              this.companyProfileFieldValues[item.fieldId] = ''
            }
          }
        }
      }
    },
    onFetchCompanyFieldsDataFailed: function (resp) {
      this.createCompany = false
      this.$parent.$parent.onFail(resp)
    },
    isCompanyProfileFieldValid: function (fieldId, index) {
      if (!this.createCompany) {
        return true
      }
      if (this.companyProfileFields[index].selectableValues) {
        if (this.companyProfileFieldValues[fieldId] !== '') {
          return true
        } else {
          return false
        }
      } else if (validate.fieldIsValid(this.companyProfileFieldValues[fieldId], this.companyProfileFields[index].fieldValidation.regularExpression) && !validate.fieldContainsInvalidCharacter(this.companyProfileFieldValues[fieldId], this.companyProfileFields[index].fieldValidation.negativeRegularExpression) && this.companyProfileFieldValues[fieldId] !== '' && this.companyProfileFieldValues[fieldId].length <= this.companyProfileFields[index].fieldValidation.maxLength) {
        return true
      } else {
        return false
      }
    },
    getCompanyProfileFieldError: function (fieldId, index) {
      if (this.companyProfileFieldValues[fieldId] === '') {
        return this.$t('common.validation.field.empty')
      } else if (this.companyProfileFieldValues[fieldId].length > this.companyProfileFields[index].fieldValidation.maxLength) {
        return this.$t('common.validation.field.fieldValidation.maxLength', { 0: this.companyProfileFields[index].fieldValidation.maxLength })
      } else if (!validate.fieldIsValid(this.companyProfileFieldValues[fieldId], this.companyProfileFields[index].fieldValidation.regularExpression) || validate.fieldContainsInvalidCharacter(this.companyProfileFieldValues[fieldId], this.companyProfileFields[index].fieldValidation.negativeRegularExpression)) {
        return this.$t('common.validation.field.format')
      }
    },
    getCompanyFields: function () {
      var companyFields = {}
      if (this.createCompany) {
        for (const [key, value] of Object.entries(this.companyProfileFieldValues)) {
          var field = this.companyProfileFields.find(i => i.fieldId === key)
          if (field && field.fieldName) {
            companyFields[field.fieldName] = value
          }
        }
      }
      return companyFields
    },
    companyFormValid: function () {
      var isValid = true
      for (let i = 0; i < this.companyProfileFields.length; i++) {
        var item = this.companyProfileFields[i]
        if (this.isCompanyProfileFieldValid(item.fieldId, i) === false) {
          isValid = false
          break
        }
      }
      return isValid
    },
    onInput: function () {
      this.showErrors = !this.showErrors
      this.showErrors = !this.showErrors
    },
    onContinue: function (fieldId) {
      this.showErrors = false
      this.showErrors = true
      return this.$parent.$parent.onContinue()
    }
  },
  computed: {
    companyRegistrationEnabled: function () {
      return this.$store.state.isCompanyRegistrationEnabled
    }
  }
}
</script>
